import React, { useState, useRef } from 'react';
import { Dialog, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function PinModal({ open, handleClose, handleBack, onConfirm, isLoading }) {
  const [pin, setPin] = useState(['', '', '', '']);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  const handleChange = (index, value) => {
    // Only allow numbers
    if (value && !/^\d+$/.test(value)) return;

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    // Move to next input if there's a value
    if (value && index < 3) {
      inputRefs[index + 1].current.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Move to previous input on backspace if current is empty
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const isPinComplete = pin.every(digit => digit !== '');

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: '24px',
          padding: '24px',
          backgroundColor: '#FAFAFB',
          boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-10">
        <div className="flex items-center gap-3">
          <IconButton onClick={handleBack} size="small">
            <ArrowBackIcon fontSize="small" style={{ color: '#1A1A1B' }} />
          </IconButton>
          <span className="font-bold text-[14px] text-back-color2">Back</span>
        </div>
        <div 
          onClick={handleClose}
          className="w-8 h-8 rounded-full bg-[#1A1A1B] flex items-center justify-center cursor-pointer hover:bg-gray-800"
        >
          <CloseIcon fontSize="small" style={{ color: 'white' }} />
        </div>
      </div>

      <div className="text-center mb-10">
        <h2 className="text-[16px] font-bold text-back-color2 mb-2">Enter your Zouse PIN</h2>
        <p className="text-[12px] text-gray-500">Enter your 4-Digit PIN to confirm transaction</p>
      </div>

      <div className="flex justify-center gap-4 mb-16">
        {pin.map((digit, index) => (
          <input
            key={index}
            ref={inputRefs[index]}
            type="password"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            className={`w-16 h-16 text-center text-2xl font-bold rounded-xl outline-none transition-colors ${
              digit 
                ? 'bg-[#E6F8F0] border border-[#00BC67] text-[#1A1A1B]' 
                : 'bg-[#F3F4F6] border border-transparent'
            }`}
          />
        ))}
      </div>

      <button 
        onClick={() => onConfirm(pin.join(''))}
        disabled={!isPinComplete || isLoading}
        className={`w-full font-bold h-[52px] rounded-xl text-[14px] transition-colors flex items-center justify-center gap-2 ${
          isPinComplete 
            ? 'bg-primary-color text-white hover:bg-[#00a359]' 
            : 'bg-[#E6F8F0] text-[#00BC67] opacity-60 cursor-not-allowed'
        }`}
      >
        {isLoading ? (
          <CircularProgress size={20} style={{ color: 'white' }} />
        ) : (
          "Confirm"
        )}
      </button>

    </Dialog>
  );
}

export default PinModal;
